import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { getRoundedClassName } from '../utils';
import { PageCollectionConfigRadiusClassName } from '@creator-suite/page-types';

export type TextFieldProps = {
  error?: string | false;
  label?: string;
  size?: 'default' | 'sm';
  className?: string;
  roundedClassName?: PageCollectionConfigRadiusClassName;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  (
    { error, label, size = 'default', className, roundedClassName, ...props },
    ref,
  ) => {
    return (
      <div className={clsx('block space-y-1 text-center', className)}>
        {label && (
          <label className="inline-block tracking-tight text-white transition">
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={clsx(
            'block w-full appearance-none border-[0.5px] bg-white/10 px-4 py-2 text-center transition placeholder:text-white/50 focus:border-white focus:outline-hidden',
            error
              ? 'border-red-600 text-red-600'
              : 'border-white/50 text-white',
            size === 'default' ? 'text-md' : 'text-lg',
            getRoundedClassName(roundedClassName),
          )}
          {...props}
        />
        {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
      </div>
    );
  },
);

TextField.displayName = 'TextField';
